import axios from 'axios';
import { NikeWebCommon } from '../../types/generated/nike-web-common';

export const getFooterPartners = async () => {
    return axios.get<never, NikeWebCommon.FooterPartnerDTO[]>('/api/footer-partners');
};

export const getFooterPaymentMethods = async () => {
    return axios.get<never, NikeWebCommon.FooterLogoDTO[]>('/api/footer-payment-methods');
};
